import { ServerFetch } from '../main-model'

export default class StockZoneListModel extends ServerFetch {
    getStockZoneListBy = (data) => this.authFetch({
        url: 'stock-zone-list/getStockZoneListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}